// customStyles do react-data-table-component no visual JDS (o escopo
// .jds-scope precisa envolver a tabela para os tokens resolverem). Fundo e texto
// por token (layer01 = branco no light): sem isso a lib pinta #FFF e vira bloco branco no dark.
const surface = {
  backgroundColor: 'var(--bg-neutral-layer01)',
  color: 'var(--fg-neutral-default)',
};

export const jdsTableStyles = {
  table: { style: surface },
  header: { style: surface },
  subHeader: { style: surface },
  noData: { style: surface },
  progress: { style: surface },
  headRow: {
    style: {
      minHeight: 48,
      backgroundColor: 'var(--bg-neutral-layer01)',
      borderBottomColor: 'var(--border-neutral-subtle)',
    },
  },
  headCells: {
    style: {
      fontSize: 'var(--fs-13)',
      fontWeight: 'var(--fw-medium)',
      color: 'var(--fg-neutral-subtle)',
    },
  },
  rows: {
    style: {
      minHeight: 56,
      fontSize: 'var(--fs-14)',
      backgroundColor: 'var(--bg-neutral-layer01)',
      color: 'var(--fg-neutral-default)',
      borderBottomColor: 'var(--border-neutral-subtle)',
    },
    // hover como overlay: o state-hover é translúcido e não pode virar o fundo da linha
    highlightOnHoverStyle: {
      color: 'var(--fg-neutral-strong)',
      backgroundColor: 'var(--bg-neutral-layer01)',
      backgroundImage:
        'linear-gradient(var(--state-hover), var(--state-hover))',
      borderBottomColor: 'var(--border-neutral-subtle)',
      outlineColor: 'var(--bg-neutral-layer01)',
    },
  },
  cells: {
    style: {
      fontSize: 'var(--fs-14)',
    },
  },
  pagination: {
    style: {
      ...surface,
      color: 'var(--fg-neutral-subtle)',
      borderTopColor: 'var(--border-neutral-subtle)',
    },
    pageButtonsStyle: {
      color: 'var(--fg-neutral-subtle)',
      fill: 'var(--fg-neutral-subtle)',
      '&:disabled': {
        color: 'var(--state-disabled-outlined-fg)',
        fill: 'var(--state-disabled-outlined-fg)',
      },
      '&:hover:not(:disabled)': { backgroundColor: 'var(--state-hover)' },
      '&:focus': { backgroundColor: 'var(--state-hover)' },
    },
  },
};
